import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListTrans = createAsyncThunk(
  "TransportNameList/fetchListTrans",
  async (cmpdetail, { rejectWithValue }) => {

    try {
      const result = await GET(`/transport/${cmpdetail?.key}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const TransportNameListSlice = createSlice({
  name: "TransportNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListTrans.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListTrans.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListTrans.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default TransportNameListSlice.reducer;
